import { LoadablePaint } from '@confluence/loadable';

export const AttachmentsPageLoader = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-AttachmentsPage" */ '../src/AttachmentsPage.tsx'))
			.AttachmentsPage,
});
